// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-group input:disabled {
  background-color: #e9ecef !important;
  cursor: not-allowed;
}

.input-group-text:disabled {
  cursor: not-allowed;
}

.disabled-input {
  cursor: not-allowed;
}

.info-text {
  font-size: 12px;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/edozvola/cases/request-attachments/request-attachments.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;AACF","sourcesContent":[".input-group input:disabled {\n  background-color: #e9ecef !important;\n  cursor: not-allowed;\n}\n\n.input-group-text:disabled {\n  cursor: not-allowed;\n}\n\n.disabled-input {\n  cursor: not-allowed;\n}\n\n.info-text {\n  font-size: 12px;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
